module.exports = "<span ng-bind='vm.message'></span>";


//////////////////
// WEBPACK FOOTER
// ./src/app.retailer.common/components/campaign-keywords/campaign-keywords.html
// module id = 25
// module chunks = 0 1 3 4